import React from 'react';

import { ReactComponent as PhoneIcon } from '../../assets/icons/phone.svg';

import './style.css';

interface PhoneButtonProps {
    type: 'call' | 'accept' | 'hang';
    onClick?: VoidFunction;
}

export const PhoneButton: React.FC<PhoneButtonProps> = (props) => {
    const classNames = ['icon--phone', props.type];

    return (
        <div className={classNames.join(' ')} onClick={props.onClick}>
            <PhoneIcon />
        </div>
    );
};
